import axios from "axios";
import { devError } from "../utils/logger";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const APIv1 = axios.create({
  baseURL: `${BASE_URL}/api/v1`,
});

// Universal wrapper
export const apiRequest = async (callback) => {
  try {
    await APIv1.get(`/public/health`, { timeout: 2000 });
    // If backend healthy → run the actual API request

    return callback(APIv1);
  } catch (error) {
    devError("Backend is not working:", error);
    throw error;
  }
};
